<template>
  <UserForm :editMode="true"></UserForm>
</template>

<script>
import UserForm from "@/components/ModuleBasedComponents/users/UserForm.vue";
export default {
  components: {
    UserForm,
  },
  mounted() {
  },
};
</script>

<style>
</style>